@if ((isGranted$ | async) === false) {
  <mat-icon>lock</mat-icon>
} @else {
  <ng-content></ng-content>
}
